export const colorType = { red: 'e20b2b', yellow: 'ffff00', green: '008080', grey: 'b6b5b7' }
export const radiusUnit = 0.5
export const diameterUnit = 0.2 // units for radius of the cyclinder.
export const headlineNews = [
  'Status quo - before the merger',
  'Status quo - before the merger',
  'Status quo - before the merger',
  'Merger announced',
  'Post merger chaos',
  'Post merger chaos',
  'Post merger chaos',
  'New reality and norms setting in + mass SALES departure',
  'New reality and norms setting in + mass SALES departure',
  'New reality and norms setting in + mass SALES departure',
  'Performance beginning to normalize',
  'Performance beginning to normalize'
]
// export const SLT = [{
// month: 1,//
// department: 'Leader',
//     type: 'SLT',
//     members: 8,
//     score: 83,
// }]
export const SLT = [
  {
    month: 1,
    department: 'Leader',
    type: 'SLT',
    members: 8,
    score: [83, 83, 82, 23, 83, 62, 35, 39, 60, 60, 60, 83]
  }
]

export const SMTs = [
  {
    department: 'Merchandising',
    goal: [['g', 'r', 'g'], ['y', 'y', 'g'], ['y', 'y', 'g'], ['r', 'r', 'r'], ['r', 'r', 'r'], ['r', 'y', 'y'], ['y', 'y', 'g'], ['y', 'g', 'g'], ['y', 'g', 'g'], ['r', 'r', 'r'], ['r', 'r', 'r'], ['r', 'y', 'y']],
    type: 'SMT',
    members: 8,
    score: [62, 59, 62, 49, 47, 47, 30, 45, 50, 20, 30, 35],
    headline: [
      'Quotas on track',
      'Quotas on track',
      'Quotas on track',
      'need plan for faster growth',
      'working on new sales plan, hiring',
      'working on new sales plan, hiring',
      'Lost 2 key leaders',
      'Great new team',
      'Gelling new team',
      '20% sales staff left to competition',
      're-hiring attrition losses',
      'new goals off track'
    ],
    OTs: [
      {
        department: 'Merchandising',
        type: 'OT',
        members: 6,
        score: [77, 79, 81, 68, 65, 65, 66, 70, 70, 70, 70, 70]
      },
      {
        department: 'Merchandising',
        type: 'OT',
        members: 6,
        score: [72, 69, 72, 59, 55, 55, 51, 51, 59, 20, 45, 30]
      },
      {
        department: 'Merchandising',
        type: 'OT',
        members: 3,
        score: [54, 55, 56, 21, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        department: 'Merchandising',
        type: 'OT',
        members: 6,
        score: [44, 46, 48, 29, 45, 45, 41, 41, 49, 66, 55, 55]
      },
      {
        department: 'Merchandising',
        type: 'OT',
        members: 6,
        score: [81, 78, 81, 60, 60, 60, 56, 56, 64, 64, 78, 87]
      },
      {
        department: 'Merchandising',
        type: 'OT',
        members: 8,
        score: [66, 67, 68, 55, 60, 60, 40, 45, 30, 55, 81, 84]
      },
      {
        department: 'Merchandising',
        type: 'OT',
        members: 10,
        score: [32, 34, 36, 1, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    ]
  },
  {
    department: 'IT',
    goal: [
      ['g', 'g', 'g'],
      ['g', 'g', 'g'],
      ['g', 'g', 'g'],
      ['r', 'r', 'r'],
      ['r', 'r', 'r'],
      ['r', 'y', 'y'],
      ['y', 'y', 'y'],
      ['g', 'g', 'g'],
      ['y', 'y', 'g'],
      ['y', 'y', 'g'],
      ['g', 'g', 'g'],
      ['g', 'g', 'g'],
    ],
    type: 'SMT',
    members: 15,
    score: [82, 83, 84, 61, 55, 55, 84, 84, 84, 84, 85, 85],
    headline: [
      'Smooth sailing, ERP hiccups',
      'Smooth sailing, ERP hiccups',
      'Smooth sailing, ERP hiccups',
      'big integration challenge ahead',
      'integration fires/planning',
      'integration fires/planning',
      'integration progress',
      'integration progress',
      'integration progress',
      'integration progress',
      'normalizing new structures',
      'normalizing new structures'
    ],
    OTs: [
      {
        department: 'IT',
        type: 'OT',
        members: 14,
        score: [80, 77, 80, 61, 38, 38, 55, 55, 65, 65, 65, 65]
      },
      {
        department: 'IT',
        type: 'OT',
        members: 6,
        score: [60, 61, 62, 41, 55, 55, 55, 35, 39, 77, 82, 82]
      },
      {
        department: 'IT',
        type: 'OT',
        members: 10,
        score: [77, 79, 81, 68, 65, 65, 66, 70, 70, 70, 70, 70]
      }
    ]
  },
  {
    department: 'Supply Chain',
    goal: [
      ['r', 'g', 'g'],
      ['r', 'g', 'g'],
      ['r', 'g', 'g'],
      ['r', 'g', 'g'],
      ['r', 'g', 'y'],
      ['r', 'g', 'g'],
      ['r', 'g', 'g'],
      ['r', 'y', 'y'],
      ['r', 'y', 'y'],
      ['r', 'g', 'y'],
      ['r', 'g', 'y'],
      ['r', 'y', 'y'],
    ],
    type: 'SMT',
    members: 7,
    score: [70, 72, 74, 66, 66, 66, 75, 60, 60, 60, 60, 60],
    headline: [
      'Continuous improvement',
      'Continuous improvement',
      'Continuous improvement',
      'focused on existing challenges',
      'focused on existing challenges',
      'focused on existing challenges',
      'focused on existing challenges',
      'integration challenges',
      'integration challenges',
      'integration challenges',
      'integration challenges',
      'integration challenges'
    ],
    OTs: [
      {
        department: 'Supply Chain',
        type: 'OT',
        members: 12,
        score: [56, 53, 56, 21, 15, 15, 15, 10, 10, 10, 4, 4]
      },
      {
        department: 'Supply Chain',
        type: 'OT',
        members: 8,
        score: [59, 60, 61, 42, 60, 60, 60, 68, 68, 68, 62, 62]
      },
      {
        department: 'Supply Chain',
        type: 'OT',
        members: 8,
        score: [44, 46, 48, 27, 60, 60, 60, 55, 55, 55, 49, 49]
      },
      {
        department: 'Supply Chain',
        type: 'OT',
        members: 5,
        score: [34, 31, 34, 21, 20, 20, 20, 28, 28, 28, 22, 22]
      },
      {
        department: 'Supply Chain',
        type: 'OT',
        members: 7,
        score: [77, 78, 79, 44, 55, 55, 55, 50, 50, 50, 44, 44]
      },
      {
        department: 'Supply Chain',
        type: 'OT',
        members: 4,
        score: [83, 85, 87, 68, 68, 68, 68, 76, 76, 76, 70, 70]
      },
      {
        department: 'Supply Chain',
        type: 'OT',
        members: 9,
        score: [21, 18, 21, 0, 30, 39, 45, 60, 60, 60, 65, 65]
      }
    ]
  },
  {
    department: 'Stores',
    goal: [
      ['y', 'y', 'g'],
      ['y', 'r', 'g'],
      ['y', 'r', 'g'],
      ['y', 'r', 'g'],
      ['r', 'r', 'r'],
      ['y', 'r', 'r'],
      ['y', 'r', 'r'],
      ['y', 'y', 'r'],
      ['y', 'y', 'r'],
      ['y', 'r', 'y'],
      ['y', 'y', 'y'],
      ['y', 'g', 'g'],
    ],
    type: 'SMT',
    members: 6,
    score: [66, 63, 66, 60, 35, 35, 30, 55, 55, 65, 65, 66],
    headline: [
      'Some choppy water',
      'Some choppy water',
      'Some choppy water',
      'doing our jobs',
      '30% layoffs',
      '30% layoffs',
      'lost 3 key leaders',
      'Building new team',
      'Building new team',
      'early progress with new team',
      'more progress with new team',
      'layoff recovery in sight'
    ],
    OTs: [
      {
        department: 'Stores',
        type: 'OT',
        members: 7,
        score: [91, 92, 93, 80, 60, 60, 68, 68, 68, 62, 62]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 6,
        score: [81, 83, 85, 50, 45, 45, 40, 40, 40, 34, 34]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 8,
        score: [84, 81, 84, 65, 70, 70, 78, 78, 78, 72, 72]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 8,
        score: [84, 85, 86, 67, 55, 55, 40, 40, 50, 50, 53, 53]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 11,
        score: [66, 68, 70, 57, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 9,
        score: [82, 79, 82, 47, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 9,
        score: [84, 85, 86, 67, 55, 55, 40, 40, 50, 50, 53, 53]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 3,
        score: [44, 46, 48, 27, 60, 60, 45, 45, 55, 55, 58, 58]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 6,
        score: [89, 86, 89, 76, 70, 70, 55, 55, 65, 65, 68, 68]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 5,
        score: [77, 78, 79, 44, 66, 66, 51, 51, 61, 61, 64, 64]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 8,
        score: [82, 84, 86, 67, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        department: 'Stores',
        type: 'OT',
        members: 11,
        score: [89, 86, 89, 68, 42, 42, 27, 27, 37, 37, 40, 55]
      }
    ]
  },
  {
    department: 'Marketing',
    goal: [
      ['g', 'r', 'g'],
      ['g', 'y', 'g'],
      ['g', 'y', 'g'],
      ['g', 'y', 'g'],
      ['y', 'r', 'y'],
      ['y', 'r', 'y'],
      ['y', 'r', 'y'],
      ['y', 'y', 'y'],
      ['g', 'y', 'y'],
      ['g', 'g', 'g'],
      ['g', 'g', 'g'],
      ['g', 'g', 'g']
    ],
    type: 'SMT',
    members: 4,
    score: [75, 76, 77, 60, 55, 55, 70, 70, 73, 73, 88, 87],
    headline: [
      'On plan',
      'On plan',
      'On plan',
      'waiting for direction',
      'are we changing strategy?',
      'are we changing strategy?',
      'new direction clear now',
      'working ahead with new plan',
      'new plan is exciting',
      'new plan is exciting',
      'funnel total up 34%',
      'conversions up 4%'
    ],
    OTs: [
      {
        department: 'Marketing',
        type: 'OT',
        members: 3,
        score: [88, 89, 90, 77, 84, 84, 82, 82, 40, 20, 30, 49]
      },
      {
        department: 'Marketing',
        type: 'OT',
        members: 5,
        score: [62, 64, 66, 31, 60, 60, 65, 81, 81, 60, 55, 65]
      },
      {
        department: 'Marketing',
        type: 'OT',
        members: 4,
        score: [77, 74, 77, 58, 75, 75, 75, 81, 84, 39, 45, 55]
      }
    ]
  },
  {
    department: 'Finance',
    goal: [
      ['g', 'y', 'y'],
      ['g', 'y', 'g'],
      ['g', 'y', 'g'],
      ['g', 'y', 'g'],
      ['y', 'y', 'g'],
      ['y', 'y', 'g'],
      ['g', 'g', 'r'],
      ['g', 'g', 'r'],
      ['r', 'r', 'r'],
      ['r', 'r', 'r'],
      ['r', 'r', 'r'],
      ['r', 'y', 'y']
    ],
    type: 'SMT',
    members: 5,
    score: [85, 87, 89, 65, 81, 81, 84, 81, 35, 25, 30, 41],
    headline: [
      'Aligned and thriving',
      'Aligned and thriving',
      'Aligned and thriving',
      'exciting challenge ahead',
      'lots of people to help',
      'lots of people to help',
      'lots of people to help',
      'culture work green shoots',
      '2 key leaders quit',
      '2 of us overloaded',
      '3 of us overloaded',
      'rebuilding team'
    ],
    OTs: [
      {
        department: 'Finance',
        type: 'OT',
        members: 8,
        score: [32, 34, 36, 1, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        department: 'Finance',
        type: 'OT',
        members: 3,
        score: [88, 90, 92, 79, 82, 82, 81, 83, 83, 83, 86, 86]
      },
      {
        department: 'Finance',
        type: 'OT',
        members: 6,
        score: [45, 42, 45, 10, 55, 55, 55, 66, 66, 65, 65, 65]
      }
    ]
  },
  {
    department: 'E-Commerce',
    goal: [
      ['r', 'r', 'y'],
      ['r', 'g', 'y'],
      ['r', 'g', 'y'],
      ['r', 'r', 'r'],
      ['r', 'r', 'r'],
      ['y', 'y', 'r'],
      ['y', 'y', 'y'],
      ['y', 'y', 'y'],
      ['y', 'y', 'g'],
      ['y', 'y', 'g'],
      ['y', 'g', 'g'],
      ['y', 'g', 'g']
    ],
    type: 'SMT',
    members: 5,
    score: [39, 36, 39, 10, 35, 35, 60, 75, 60, 65, 65, 70],
    headline: [
      '',
      'Struggling with direction',
      'Struggling with direction',
      'R&D leadership replaced',
      'new leadership, new energy',
      'new leadership, new energy',
      'new team forming',
      'opportunities compelling',
      'opportunities compelling',
      'making progress on new goals',
      'making progress on new goals',
      'new goals on track'
    ],
    OTs: [
      {
        department: 'E-Commerce',
        type: 'OT',
        members: 13,
        score: [47, 48, 49, 30, 20, 20, 40, 40, 35, 35, 55, 55]
      },
      {
        department: 'E-Commerce',
        type: 'OT',
        members: 11,
        score: [23, 25, 27, 6, 54, 54, 66, 66, 66, 66, 66, 66]
      },
      {
        department: 'E-Commerce',
        type: 'OT',
        members: 10,
        score: [55, 52, 55, 42, 81, 81, 81, 45, 45, 55, 55, 60]
      }
    ]
  },
  {
    department: 'Channel Partners',
    goal: [
      ['r', 'g', 'y'],
      ['y', 'g', 'y'],
      ['y', 'g', 'y'],
      ['y', 'y', 'y'],
      ['y', 'y', 'y'],
      ['y', 'y', 'y'],
      ['y', 'y', 'y'],
      ['y', 'g', 'y'],
      ['y', 'g', 'g'],
      ['y', 'g', 'g'],
      ['y', 'g', 'g'],
      ['g', 'g', 'g']
    ],
    type: 'SMT',
    members: 3,
    score: [73, 74, 75, 50, 51, 51, 82, 82, 81, 87, 88, 85],
    headline: [
      'Excited for future',
      'Excited for future',
      'Excited for future',
      'excited but uncertain now?',
      'waiting to see',
      'waiting to see',
      'feeling strongly supported',
      'feeling strongly supported',
      'Venture 3 major win',
      'Venture 3 growth',
      'Venture 3 growth',
      'Venture 5 kicked off'
    ],
    OTs: [
      {
        department: 'Channel Partners',
        type: 'OT',
        members: 8,
        score: [88, 89, 90, 55, 60, 60, 60, 60, 60, 60, 60, 60]
      },
      {
        department: 'Channel Partners',
        type: 'OT',
        members: 5,
        score: [24, 26, 28, 9, 45, 45, 45, 30, 30, 30, 55, 70]
      },
      {
        department: 'Channel Partners',
        type: 'OT',
        members: 9,
        score: [77, 74, 77, 56, 82, 82, 82, 82, 90, 90, 90, 90]
      },
      {
        department: 'Channel Partners',
        type: 'OT',
        members: 7,
        score: [81, 82, 83, 70, 84, 84, 60, 60, 77, 77, 83, 83]
      }
    ]
  }
]
